/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

interface BannerCardProps {
  name: string
  image: string
  cardStyle: any
}

const BannerCard = (props: BannerCardProps) => {
  const {
    name = '',
    image = '',
    cardStyle
  } = props
  return (
    (image !== '') &&
    (
      <div className="w-full">
        <div style={cardStyle}>
          <Image
            src={image}
            alt={name}
            width={1200}
            height={220}
            priority
            className="block w-full h-auto rounded-bl-[32px] rounded-br-[32px] sm:rounded-none"
          />
        </div>
      </div>
    )
  )
}

BannerCard.propTypes = {
  name: PropTypes.string,
  image: PropTypes.string,
  cardStyle: PropTypes.shape({})
}

export default BannerCard
